<template>
  <div v-if="Servicio">
    <!-- Start Breadcrump Area  -->
    <div class="rn-page-title-area pt--120 pb--190 banner-service-details-notin" data-black-overlay="5">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="rn-page-title text-center pt--100">
              <h2 class="headingtitle">{{ Servicio.Titulo }}</h2>
              <h3 v-if="Servicio.Subtitulo">{{ Servicio.Subtitulo }}</h3>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <div class="rn-service-details rn-section-gap bg_color--1 content-service-details-notin">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="inner">
              <!-- Start Single Content  -->
              <v-row class="pb--80 align-items-center">
                <v-col lg="8" md="8" cols="12" class="content">
                  <div class="mt_md--30 mt_sm--30 text-justify">
                    <span class="content-service-details-notin" v-thtml="Servicio.Contenido"/>
                  </div>
                </v-col>
                <v-col lg="4" md="4" cols="12" v-if="Servicio.Imagen">
                  <div class="thumb">
                    <img class="w-100" :src="imagenIDtoSRC(Servicio.Imagen)" alt="Service Images" />
                  </div>
                </v-col>
              </v-row>
              <!-- End Single Content  -->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useStore } from '../../store/index'
const store = useStore()
import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()
import { useRoute } from 'vue-router';
const route = useRoute()
const Servicio = ref(null)


import { useStyles } from '../../store/styles';
const style = useStyles();

// const estiloTituloColor = style.ThemeSectionServicios.Titulo.css.Color
// const estiloTituloBackgroundColor = style.ThemeSectionServicios.Titulo.css.BackgroundColor
// const estiloTituloShadow = style.ThemeSectionServicios.Titulo.css.BackgroundColor ? "4px 2px 6px "+style.ThemeSectionServicios.Titulo.css.BackgroundColor:""
// const estiloTituloFont = style.ThemeSectionServicios.Titulo.css.Font
// const estiloTituloSize = style.ThemeSectionServicios.Titulo.css.Size
// const estiloTituloWeight = style.ThemeSectionServicios.Titulo.css.Weight
// const estiloTituloAlign = style.ThemeSectionServicios.Titulo.css.Align

// const estiloDescripcionColor = style.ThemeSectionServicios.Descripcion.css.Color
// const estiloDescripcionBackgroundColor = style.ThemeSectionServicios.Descripcion.css.BackgroundColor
// const estiloDescripcionShadow = style.ThemeSectionServicios.Descripcion.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Descripcion.css.BackgroundColor:""
// const estiloDescripcionFont = style.ThemeSectionServicios.Descripcion.css.Font
// const estiloDescripcionSize = style.ThemeSectionServicios.Descripcion.css.Size
// const estiloDescripcionWeight = style.ThemeSectionServicios.Descripcion.css.Weight
// const estiloDescripcionAlign = style.ThemeSectionServicios.Descripcion.css.Align

// const estiloTarjetaTituloColor = style.ThemeSectionServicios.Tarjeta.Titulo.css.Color
// const estiloTarjetaTituloShadow = style.ThemeSectionServicios.Tarjeta.Titulo.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Tarjeta.Titulo.css.BackgroundColor:""
// const estiloTarjetaTituloFont = style.ThemeSectionServicios.Tarjeta.Titulo.css.Font
// const estiloTarjetaTituloSize = style.ThemeSectionServicios.Tarjeta.Titulo.css.Size
// const estiloTarjetaTituloWeight = style.ThemeSectionServicios.Tarjeta.Titulo.css.Weight
// const estiloTarjetaTituloAlign = style.ThemeSectionServicios.Tarjeta.Titulo.css.Align

// const estiloTarjetaDescripcionColor = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Color
// const estiloTarjetaDescripcionShadow = style.ThemeSectionServicios.Tarjeta.Descripcion.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Tarjeta.Descripcion.css.BackgroundColor:""
// const estiloTarjetaDescripcionFont = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Font
// const estiloTarjetaDescripcionSize = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Size
// const estiloTarjetaDescripcionWeight = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Weight
// const estiloTarjetaDescripcionAlign = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Align

const estiloTarjetaFondoColor = "linear-gradient(to right," +style.ThemeSectionServicios.Tarjeta.FondoCSS.BackgroundColor+","+style.ThemeSectionServicios.Tarjeta.FondoCSS.BackgroundColorGradient+")" 

const imgFiltro = style.ThemeSectionServicios?.ImagenFiltro ? style.ThemeSectionServicios.ImagenFiltro : ""
const img = style.ThemeSectionServicios?.Imagen ? "url(" + imagenIDtoSRC(style.ThemeSectionServicios.Imagen)+ ")" : ""

const estiloDetallesTituloBannerColor = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Color
const estiloDetallesTituloBannerShadow = style.ThemeSectionServicios.Detalles.TituloBannerCSS.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.TituloBannerCSS.BackgroundColor:""
const estiloDetallesTituloBannerFont = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Font
const estiloDetallesTituloBannerSize = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Size
const estiloDetallesTituloBannerWeight = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Weight
const estiloDetallesTituloBannerAlign = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Align

const estiloDetallesSubtituloBannerColor = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Color
const estiloDetallesSubtituloBannerShadow = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.TituloBannerCSS.BackgroundColor:""
const estiloDetallesSubtituloBannerFont = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Font
const estiloDetallesSubtituloBannerSize = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Size
const estiloDetallesSubtituloBannerWeight = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Weight
const estiloDetallesSubtituloBannerAlign = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Align

const estiloDetallesH1Color = style.ThemeSectionServicios.Detalles.H1.Color
const estiloDetallesH1Shadow = style.ThemeSectionServicios.Detalles.H1.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.H1.BackgroundColor:""
const estiloDetallesH1Font = style.ThemeSectionServicios.Detalles.H1.Font
const estiloDetallesH1Size = style.ThemeSectionServicios.Detalles.H1.Size
const estiloDetallesH1Weight = style.ThemeSectionServicios.Detalles.H1.Weight
const estiloDetallesH1Align = style.ThemeSectionServicios.Detalles.H1.Align

const estiloDetallesH2Color = style.ThemeSectionServicios.Detalles.H2.Color
const estiloDetallesH2Shadow = style.ThemeSectionServicios.Detalles.H2.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.H2.BackgroundColor:""
const estiloDetallesH2Font = style.ThemeSectionServicios.Detalles.H2.Font
const estiloDetallesH2Size = style.ThemeSectionServicios.Detalles.H2.Size
const estiloDetallesH2Weight = style.ThemeSectionServicios.Detalles.H2.Weight
const estiloDetallesH2Align = style.ThemeSectionServicios.Detalles.H2.Align

const estiloDetallesH3Color = style.ThemeSectionServicios.Detalles.H3.Color
const estiloDetallesH3Shadow = style.ThemeSectionServicios.Detalles.H3.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.H3.BackgroundColor:""
const estiloDetallesH3Font = style.ThemeSectionServicios.Detalles.H3.Font
const estiloDetallesH3Size = style.ThemeSectionServicios.Detalles.H3.Size
const estiloDetallesH3Weight = style.ThemeSectionServicios.Detalles.H3.Weight
const estiloDetallesH3Align = style.ThemeSectionServicios.Detalles.H3.Align

const estiloDetallesPColor = style.ThemeSectionServicios.Detalles.p.Color
const estiloDetallesPShadow = style.ThemeSectionServicios.Detalles.p.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.p.BackgroundColor:""
const estiloDetallesPFont = style.ThemeSectionServicios.Detalles.p.Font
const estiloDetallesPSize = style.ThemeSectionServicios.Detalles.p.Size
const estiloDetallesPWeight = style.ThemeSectionServicios.Detalles.p.Weight
const estiloDetallesPAlign = style.ThemeSectionServicios.Detalles.p.Align

const estiloDetallesFondoBanner = "linear-gradient(to bottom," + style.ThemeSectionServicios.Detalles.FondoBannerCSS.BackgroundColor +" 0,"+ style.ThemeSectionServicios.Detalles.FondoBannerCSS.BackgroundColorGradient+" 100%)"

//////console.log(this.$route.params.id)
var slug:string = route.params.id.toString()
if(store.NOTARIA){
  Servicio.value = store.NOTARIA.Servicios.find(x => x.Slug === slug);
  if (!Servicio.value)
    route.push("/404")
  else if (!Servicio.value?.Publicado)
    route.push("/404")

}
const PageName = "Servicios"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName,slug)
</script>
<style lang="scss">

  .banner-service-details-notin h2{
    color:v-bind(estiloDetallesTituloBannerColor)  !important;
    text-shadow:v-bind(estiloDetallesTituloBannerShadow)  !important;
    font-family:v-bind(estiloDetallesTituloBannerFont)  !important;
    font-size: v-bind(estiloDetallesTituloBannerSize) !important;
    font-weight:v-bind(estiloDetallesTituloBannerWeight) !important;
    text-align: v-bind(estiloDetallesTituloBannerAlign) !important;
  }
  .banner-service-details-notin h3{
    color:v-bind(estiloDetallesSubtituloBannerColor)  !important;
    text-shadow:v-bind(estiloDetallesSubtituloBannerShadow)  !important;
    font-family:v-bind(estiloDetallesSubtituloBannerFont)  !important;
    font-size: v-bind(estiloDetallesSubtituloBannerSize) !important;
    font-weight:v-bind(estiloDetallesSubtituloBannerWeight) !important;
    text-align: v-bind(estiloDetallesSubtituloBannerAlign) !important;
  }
  .banner-service-details-notin{
    background: v-bind(estiloDetallesFondoBanner) !important;
  }
  .content-service-details-notin h1{
    color:v-bind(estiloDetallesH1Color)  !important;
    text-shadow:v-bind(estiloDetallesH1Shadow)  !important;
    font-family:v-bind(estiloDetallesH1Font)  !important;
    font-size: v-bind(estiloDetallesH1Size) !important;
    font-weight:v-bind(estiloDetallesH1Weight) !important;
    text-align:v-bind(estiloDetallesH1Align) !important;
  }
  .content-service-details-notin h2{
    color:v-bind(estiloDetallesH2Color)  !important;
    text-shadow:v-bind(estiloDetallesH2Shadow)  !important;
    font-family:v-bind(estiloDetallesH2Font)  !important;
    font-size: v-bind(estiloDetallesH2Size) !important;
    font-weight:v-bind(estiloDetallesH2Weight) !important;
    text-align:v-bind(estiloDetallesH2Align) !important;
  }
  .content-service-details-notin h3, .content-service-details-notin a{
    color:v-bind(estiloDetallesH3Color)  !important;
    text-shadow:v-bind(estiloDetallesH3Shadow)  !important;
    font-family:v-bind(estiloDetallesH3Font)  !important;
    font-size: v-bind(estiloDetallesH3Size) !important;
    font-weight:v-bind(estiloDetallesH3Weight) !important;
    text-align:v-bind(estiloDetallesH3Align) !important;
  }
  .content-service-details-notin p{
    color:v-bind(estiloDetallesPColor)  !important;
    text-shadow:v-bind(estiloDetallesPShadow)  !important;
    font-family:v-bind(estiloDetallesPFont)  !important;
    font-size: v-bind(estiloDetallesPSize) !important;
    text-align:v-bind(estiloDetallesPAlign) !important;
    // font-weight:v-bind(estiloDetallesPWeight) !important;
  }
</style>
